<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h4>Google Tag Manager (GTM)</h4>
      </div>
      <div class="col-sm-8">
        <el-input placeholder="Please input GTM" type="text" v-model="gtm">
        </el-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <TagInput @add-new-tag="updateAccounts($event)" :accounts="accounts"/>
        <el-button @click="addGTM()" :disabled="isGTMUpdated"
          >為以上店家加入GTM</el-button
        ><span> {{displayOfUpdateGTMBtn}}</span><span><el-button v-show="isGTMUpdated" @click="clearGTMData()">新增其它GTM</el-button></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  putGtmByAccounts
} from "src/javascripts/generalPages/updateData";
import TagInput from "./TagInput.vue";

export default {
  components: {
    TagInput
  },
  data() {
    return {
      isGTMUpdated: false,
      gtm: "",
      accounts: []
    };
  },
  computed: {
    displayOfUpdateGTMBtn: function() {
        return this.isGTMUpdated === true ? "更新商店GTM成功" : "(注意！已設定過會被覆蓋)"
    }
  },
  methods: {
    updateAccounts(e) {
      this.accounts = e;
      console.log("this.accounts: ", this.accounts);
    },
    addGTM() {
      let gtm = this.gtm;
      let accounts = this.accounts;
      if (!gtm) {
        this.$message({
          type: "error",
          message: "請填入GTM"
        });
        return;
      }
      if (accounts.length === 0) {
        this.$message({
          type: "error",
          message: "請輸入商店ID"
        });
        return;
      }
      this.callAddGTMApi();
    },
    callAddGTMApi() {
        let that = this;
      let gtm = this.gtm;
      let accounts = this.accounts;
      let d = {
        accounts,
        gtm
      };
      putGtmByAccounts(d)
        .then(res => {
          this.$message({
            type: "success",
            message: "更新成功！"
          });
          that.isGTMUpdated = true;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: "更新失敗！請重新嘗試。"
          });
        });
    },
    clearGTMData() {
        this.accounts = Array.from(new Set());
        this.gtm = "";
        this.isGTMUpdated = false;
    }
  }
};
</script>

